module.exports = __webpack_public_path__ + "static/media/clock-red.74f7d8f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/clock-red.svg
// module id = 754
// module chunks = 0